$(document).ready(function(){

  // Show the first tab and hide the rest
  $('#tabs-nav li.tab-li:first-child').addClass('active');
  $('.outer-tab-content.tab-content').hide();
  $('.outer-tab-content.tab-content:first').show();
  
  // Click function
  $('#tabs-nav li.tab-li').click(function(){
    $('#tabs-nav li.tab-li').removeClass('active');
    $(this).addClass('active');
    $('.outer-tab-content.tab-content').hide();
    
    var activeTab = $(this).find('a').attr('href');
    $(activeTab).fadeIn();
    return false;
  });

  $('#inner-tabs-nav li.inner-tab-li:first-child').addClass('active');
  $('.inner-tab-section .tab-content').hide();
  $('.inner-tab-section .tab-content:first').show();
  
  $('#inner-tabs-nav li.inner-tab-li').click(function(){
    $('#inner-tabs-nav li.inner-tab-li').removeClass('active');
    $(this).addClass('active');
    $('.inner-tab-section .tab-content').hide();
    
    var activeInnerTab = $(this).find('a').attr('href');
    $(activeInnerTab).fadeIn();
    return false;
  });

    $('body').on('click', '.pro_size_btn', function() {
       $('body').toggleClass("modal-active");
    });
    $('body').on('click', '.modal-close-btn', function() {
       $('body').removeClass("modal-active");
    });  
  
});